/**
 * Parse "objectApi.field_api_name" from action propMappings (field sourceType).
 * If there is no dot, the whole string is the field API name on the current layout object.
 */
export function parseObjectFieldRef(ref) {
  const s = String(ref || '').trim();
  if (!s) return null;
  const i = s.indexOf('.');
  if (i <= 0) return { objectApi: null, fieldApi: s };
  return { objectApi: s.slice(0, i).trim(), fieldApi: s.slice(i + 1).trim() };
}

function resolveFieldRef(ref, ctx) {
  const { layoutObjectName, getFieldValueForMapping } = ctx;
  const parsed = parseObjectFieldRef(ref);
  if (!parsed) return undefined;
  const { objectApi, fieldApi } = parsed;
  const on = layoutObjectName != null ? String(layoutObjectName).toLowerCase() : '';
  const oa = objectApi != null && objectApi !== '' ? String(objectApi).toLowerCase() : null;
  if (oa && oa !== on) return undefined;
  const v = getFieldValueForMapping(fieldApi);
  return v != null && v !== '' ? v : undefined;
}

/**
 * @param {unknown} entry — string (legacy field ref) or { sourceType, value }
 * @param {{ layoutObjectName: string, getFieldValueForMapping: (fieldApi: string) => unknown }} ctx
 */
export function resolvePropMappingEntry(entry, ctx) {
  if (entry == null || entry === '') return undefined;
  if (typeof entry === 'string') {
    return resolveFieldRef(entry, ctx);
  }
  if (typeof entry === 'object') {
    const st = entry.sourceType === 'text' ? 'text' : 'field';
    if (st === 'text') {
      return entry.value != null ? String(entry.value) : '';
    }
    const ref = entry.value != null ? String(entry.value) : '';
    return resolveFieldRef(ref, ctx);
  }
  return undefined;
}

/**
 * Map action.config.propMappings to component prop bag (recordId, etc.).
 * @param {object|null|undefined} action
 * @param {{ layoutObjectName: string, getFieldValueForMapping: (fieldApi: string) => unknown }} ctx
 */
export function buildDetailCustomActionProps(action, ctx) {
  const pm = action?.config?.propMappings;
  if (!pm || typeof pm !== 'object' || Array.isArray(pm)) {
    return {};
  }
  const out = {};
  Object.entries(pm).forEach(([propName, entry]) => {
    const val = resolvePropMappingEntry(entry, ctx);
    if (val !== undefined) out[propName] = val;
  });
  return out;
}
